// extracted by mini-css-extract-plugin
export default {"container":"styles_container__Hjz9V","header":"styles_header__yvgVD","header_icon":"styles_header_icon__rXxC+","btnClose":"styles_btnClose__r51+A"};